export const ENTRY = 'Entry';
export const EXIT = 'Exit';
export const UNSUPPORT_METHOD = 'Unupported Method';
export const SENDING_REQUEST = 'Sending Request';
export const ERROR = 'Error';
export const RETURNING_RESPONSE = 'Returning Response';

export const TOKEN = {
  EXPIRED: 'Token expired. Getting new token',
  OLD_TOKEN: 'Using old token',
  NEW_TOKEN: 'Getting New Token',
};

export const ERROR_CODE = 404;
export const ERROR_KEY = 'ECT_CONN_ABORTED';
export const UNKNOWN_ERROR_MESSAGE = 'UNKNOWN_ERROR_MESSAGE';
